"use strict";
function clsx(...classNames) {
  return classNames.filter((className) => Boolean(className)).join(" ");
}
export {
  clsx
};
